import React, { useRef } from "react";
import { Box, Stack, Button } from "digiwash-components";
import { Platform, ScrollView } from "react-native";

function TabBar(props) {
  let ref = useRef(null);
  return (
    <Box>
      <Box br="l" style={{ overflow: "hidden" }}>
        <ScrollView
          horizontal
          contentContainerStyle={{
            flexGrow: 1,
          }}
          onContentSizeChange={() =>
            Platform.OS === "android"
              ? ref.current?.scrollToEnd({ animated: false })
              : null
          }
          ref={ref}
          key="Scrolling"
          style={{
            ...{
              direction: "rtl",
            },
          }}
        >
          <Stack
            br="l"
            bg="neutrals.200"
            style={{
              width: "100%",
              transform: [{ scaleX: Platform.OS === "android" ? 1 : -1 }],
            }}
          >
            {props.data?.map((item, index) => {
              return (
                <Box
                  style={{
                    flexGrow: 1,
                    transform: [{ scaleX: Platform.OS === "android" ? 1 : -1 }],
                  }}
                >
                  <Button
                    textColor={
                      props.selected === index ? "common.white" : "common.black"
                    }
                    fill={props.selected === index ? "primary" : "transparent"}
                    onPress={() => {
                      props.onSelect(index);
                    }}
                  >
                    {item.display_name ? item.display_name : item.name}
                  </Button>
                </Box>
              );
            })}
          </Stack>
        </ScrollView>
      </Box>
    </Box>
  );
}
export default TabBar;
